import * as tslib_1 from "tslib";
export function fileToBase64(file) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var fileReader, promise;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileReader = new FileReader();
                    promise = new Promise(function (resolve, reject) {
                        fileReader.onload = resolve;
                        fileReader.onerror = reject;
                        fileReader.readAsDataURL(file);
                    });
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [2 /*return*/, fileReader.result];
            }
        });
    });
}
export function fileToBuffer(file) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var fileReader, promise;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileReader = new FileReader();
                    promise = new Promise(function (resolve, reject) {
                        fileReader.onload = resolve;
                        fileReader.onerror = reject;
                        fileReader.readAsArrayBuffer(file);
                    });
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [2 /*return*/, fileReader.result];
            }
        });
    });
}
